import { render, staticRenderFns } from "./nova.vue?vue&type=template&id=25e68c70&scoped=true"
import script from "./nova.vue?vue&type=script&lang=js"
export * from "./nova.vue?vue&type=script&lang=js"
import style0 from "./nova.vue?vue&type=style&index=0&id=25e68c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e68c70",
  null
  
)

export default component.exports